import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  formatLocationCode = (e) => {
    const value = e.target.value
    const formattedValue = value.replace(/[^a-zA-Z0-9-]/g, "_")
    e.target.value = formattedValue
  }
}
